import React, { Component } from 'react'

import IconRender from './IconRender';

class BooleanIcon extends Component {

    render() {
        return (
            <React.Fragment>
                {this.props.developperView && (this.props.value ? 'true' : 'false')}
                {!this.props.developperView && this.props.value && <IconRender name="check" />}
                {!this.props.developperView && !this.props.value && <IconRender name="x" />}
            </React.Fragment>
        )
    }
}

export default (BooleanIcon)
